export interface DecodedClaims {
  email?: string;
  groups: string[];
  divisionIds: string[];
}

/** Client-side-only decode for UI purposes (hide/show nav). Never authoritative -- the API re-verifies. */
export function decodeIdToken(idToken: string): DecodedClaims {
  const payload = idToken.split('.')[1];
  if (!payload) return { groups: [], divisionIds: [] };
  const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  const groups: string[] = Array.isArray(json['cognito:groups']) ? json['cognito:groups'] : [];
  const divisionIds: string[] =
    typeof json['custom:divisionIds'] === 'string' && json['custom:divisionIds'].length > 0
      ? json['custom:divisionIds'].split(',').filter(Boolean)
      : [];
  return { email: json.email, groups, divisionIds };
}
